import { render, staticRenderFns } from "./stage-control.vue?vue&type=template&id=228f08a1"
import script from "./stage-control.vue?vue&type=script&lang=js"
export * from "./stage-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports